var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.error)?[_c('div',{staticClass:"wrap-content"},[_c('div',{staticClass:"wrap-header"},[_c('LangSwitcher'),(_vm.insert_dev_component == 'true')?_c('Login'):_vm._e()],1),_c('Receipt')],1)]:[_c('ErrorPage')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }